
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat",
      function () {
        return require("private-next-pages/chat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat"])
      });
    }
  